/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { EvmAddressSummaryInfo } from './EvmAddressSummaryInfo';
import type { SomniaTrxMoreDetailInfo } from './SomniaTrxMoreDetailInfo';
import type { SomniaTrxTokenTransferInfo } from './SomniaTrxTokenTransferInfo';

export type SomniaTrxDetailInfo = {
    TRXA: string;
    TRXTP: SomniaTrxDetailInfo.TRXTP;
    CBB: string;
    STAT: SomniaTrxDetailInfo.STAT;
    BNO: string;
    AG: string;
    FROMADDRSINFO: EvmAddressSummaryInfo;
    TOADDRSINFO: EvmAddressSummaryInfo;
    AMT: string;
    VAL: string;
    TRXF: string;
    TRXFVAL: string;
    GP: string;
    GL: string;
    GU: string;
    GUP: string;
    UT: number;
    TRXID: string;
    SNO: string;
    MTHID: string;
    MTHNM: string;
    MD: SomniaTrxMoreDetailInfo;
    MINT: Array<SomniaTrxTokenTransferInfo>;
    BURN: Array<SomniaTrxTokenTransferInfo>;
    TRANSFER: Array<SomniaTrxTokenTransferInfo>;
};

export namespace SomniaTrxDetailInfo {

    export enum TRXTP {
        NORMAL = 'NORMAL',
        INTERNAL = 'INTERNAL',
        PENDING = 'PENDING',
    }

    export enum STAT {
        SUCCESS = 'SUCCESS',
        FAILURE = 'FAILURE',
        PENDING = 'PENDING',
        FAILED = 'FAILED',
        OUT_COMING = 'OUT_COMING',
        IN_COMING = 'IN_COMING',
        ALL = 'ALL',
    }


}

